// extracted by mini-css-extract-plugin
module.exports = {"DarkOverlay":"DarkOverlay_DarkOverlay__2wQAO"};